import React from 'react';
import styled from "styled-components";

export function Indicator(props: Props) {
  return (
    <Wrapper>
      <Light />
    </Wrapper>
  )
}

interface Props {
}

const Wrapper = styled.div`
    position: absolute;
    top: 8px;
    left: 16px;
`

const Light = styled.div`
  width: 8px;
  height: 8px;  
  background: #20CC6F;
  border-radius: 50%;
  filter: drop-shadow(0 2px 2px rgba(63, 67, 74, 0.15));
`
